module.exports = __webpack_public_path__ + "img/header-landing.9e25a26f.png";